// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"PageHeader-module--PageHeader--9vm3E"};